import ProfileViewVO from '@domain/vo/profile/common/ProfileViewVO';
import { ProfileBasicRs } from '@domain/rs/profile/ProfileBasicRs';
import { VerificationType } from '@domain/constant/verificationType';
import DateFormat from '@utils/date/format';
import TextFormat from '@utils/text/format';

export default class ProfileBasicVO extends ProfileViewVO {
  profileImageUid: string | null;
  profileImageUrl: string;
  profileImageName: string | null;
  name: string | null;
  birthDate: string | null;
  birthDateText: string;
  countryCode: string | null;
  mobile: string | null;
  mobileText: string;
  email: string | null;
  isPeregrine: boolean;
  userIdentificationType: VerificationType | null;
  identified: boolean | null;

  constructor(rs: ProfileBasicRs) {
    super({
      name: rs.name,
      birthDate: rs.birthDate,
      email: rs.email,
    });

    this.profileImageUid = rs.profileImageUid;
    this.profileImageUrl = rs.profileImageUrl ?? '';
    this.profileImageName = rs.profileImageName;
    this.name = rs.name;
    this.birthDate = rs.birthDate;
    this.birthDateText = DateFormat.getDateFormatString(rs.birthDate, 'yyyy.MM.dd') ?? '';
    this.email = rs.email;
    this.isPeregrine = !rs.mobile && rs.userIdentificationType === 'IPIN';
    this.countryCode = rs.countryCode;
    this.mobile = this.isPeregrine ? '해외거주자입니다.' : rs.mobile;
    this.mobileText = this.isPeregrine ? '해외거주자입니다.' : TextFormat.formatMobileWithHypen(rs.mobile ?? ''); // - 포함한 전화번호
    this.userIdentificationType = rs.userIdentificationType;
    this.identified = rs.identified;
  }
}
